
export class Lead {
	constructor() {
		//console.log('class Lead');
	}

	//оставить заявку popup
	sendZayav1(parent) {
		this.send(parent, 11, "lid", '');
		return false;
	}
	//нужна консультация
	sendZayav2(parent) {
		this.send(parent, 11, "cons", '');
		return false;
	}
	//оформление заказа popup
	sendZayav3(parent) {
		this.send(parent, 11, "order", '');
		return false;
	}
	//калькулятор popup
	sendZayav4(parent, data) {
		let newData = data.filter(item => item.value != '').map(item => item.name + ': ' + item.value);
		this.send(parent, 11, "calc", newData.join(', <br/>'));
		return false;
	}
	
	hidePopup() {
		$('.popup-application__form-main').css('display', 'none');
		$('.popup-application__form-success').css('display', 'block');

		setTimeout(() => {
			$('.popup').removeClass('active');
			$("body").removeClass("no-scroll");
		}, 2000);
		setTimeout(() => {
			$('.popup-application__form-main').css('display', 'block');
			$('.popup-application__form-success').css('display', 'none');
		}, 3000);
	}

	send(parent, mid, leadName, data='') {
		let el = $(parent);
		let submit = el.find("input[type='submit']");
		let _this = this;
		console.log('send')
		
		$(document).css("cursor", "wait");

		$.ajax({
			url: "/ajax.php?mid=" + mid,
			type: "POST",
			data: el.serialize() + "&htm_calc=" + data  + "&str_page=" + document.title + "&mode=send_request",
			dataType: "json",
			beforeSend: function() {
				submit.prop("disabled", true)
			},
			success: function(res) {
				
				if (res["success"]) {
					submit.prop("disabled", true);
					$(".form").trigger('reset');
					
					if (leadName == 'lid') {
						_this.hidePopup();
					} else if (leadName == 'cons') {
						$('.application__form-main').css('display', 'none');
						$('.application__form-success').css('display', 'block');
					} else if (leadName == 'order') {
						$('.popup-order__form-main').css('display', 'none');
						$('.popup-order__form-success').css('display', 'block');
						setTimeout(() => {
							$('.popup').removeClass('active');
							$("body").removeClass("no-scroll");
						}, 2000);
						setTimeout(() => {
							$('.popup-order__form-main').css('display', 'block');
							$('.popup-order__form-success').css('display', 'none');
						}, 3000);
					} else if (leadName == 'calc') {
						_this.hidePopup();
						$('.calculator-form__price-value').html('0.00&#8381;');
						calculator.delete($('.calculator-form__size-item:not(":first-of-type")'));
						el.attr('onsubmit', `lead.sendZayav1(this); return false;`);
					}

					$(document).css("cursor", "auto")

				} else {
					alert(
						"Ошибка: " +
							res["error"] +
							". Пожалуйста, повторите попытку или свяжитесь с нами. Приносим извинения за неудобства."
					)
					$(document).css("cursor", "auto")

				}
			},
			error: function(e) {
				console.log(e)
			},
		})
	}
}
